import React from 'react'; // eslint-disable-line no-unused-vars
import Show from 'components/Form/Show';
/**
 * Counts the number of letters in a string.
 * @param {object} obj - The react object
 * @returns {integer} The number of letters.
 */
const letters = (obj) => {
  if (!obj) {
    return 0;
  }

  const objectType = Object.prototype.toString.call(obj);
  if (objectType === '[object Object]' && obj.props) {
    if (obj.props.children) {
      const childrenType = Object.prototype.toString.call(obj.props.children);
      if (childrenType === '[object Array]') {
        return obj.props.children.join(' ').length;
      }
      return obj.props.children.length;
    }
    if (obj.props.source) {
      return obj.props.source.length;
    }
  }

  return obj.length || 0;
};
/**
 * Summary provides a consistent structure to accordion summaries.
 *
 * @param type
 * @param index
 * @param left
 * @param right
 * @param placeholder
 *
 */
export const Summary = (props = {}) => {
  const props2 = {
    type: 'Item',
    index: -1,
    left: '',
    right: '',
    placeholder: '',
    ...props,
  };
  const defaultLeft = !props2.left && !props2.right ? props2.placeholder : props2.left;
  const title = props2.index < 0 ? props2.type : `${props2.type} ${props2.index + 1}`;
  const left = !props2.left && props2.right ? '' : defaultLeft;
  const klass = `summary-item-content ${left === props2.placeholder ? 'default' : 'has-content'}`;

  const tlen = letters(title) + 2;
  const rlen = letters(props2.right);
  let llen = letters(left);
  const mlen = 50 - tlen - rlen;
  if (llen > mlen) {
    llen = mlen - 1;
  }

  return (
    <span className={klass}>
      {props2.icon}
      <span className="index">{title}:</span>
      <span className="context">
        <strong className={`at-${llen} ${!props2.left && !props2.right ? 'italic' : ''}`}>
          {left}
        </strong>
      </span>
      <Show when={props2.right}>
        <span className="dates">
          <strong className={`at-${rlen}`}>{props2.right}</strong>
        </span>
      </Show>
    </span>
  );
};
